import type {
  FormSortEvent,
  FormSortIndividualNormalized,
} from '@/types/forms';
import type { SalesforceProduct } from '@/types/salesforce';
import { ProductSelectorService } from './ProductSelectorService';

export class FormSortAnswersService {
  private answers: FormSortEvent['answers'];

  constructor(answers: FormSortEvent['answers']) {
    this.answers = answers;
  }

  getAnswers(): FormSortEvent['answers'] {
    return this.answers;
  }

  // Pull out primary & other members for the purpose of working out what product
  // to pick.
  getNormalizedMembers(): FormSortIndividualNormalized[] {
    if (!this.answers) {
      return [];
    }

    const primaryDetails = this.answers.contact_details;
    if (!primaryDetails) {
      console.error('Error: Missing contact details in answers');
      throw new Error(
        'We couldn’t find the contact details needed to continue. Please try again.'
      );
    }
    if (!this.answers.date_of_birth) {
      console.error('Error: Missing date of birth in answers');
      throw new Error(
        'We couldn’t find the date of birth for the primary member. Please try again.'
      );
    }

    const primary: FormSortIndividualNormalized = {
      firstName: primaryDetails.first_name,
      lastName: primaryDetails.last_name,
      dateOfBirth: this.answers.date_of_birth,
      relationship: 'Primary',
    };

    const additionalMembers: FormSortIndividualNormalized[] = (
      this.answers.members || []
    ).map(member => ({
      firstName: member.first_name,
      lastName: member.last_name,
      relationship: 'Other',
      dateOfBirth: member.date_of_birth,
    }));

    return [primary, ...additionalMembers];
  }

  getSelectedProduct(): SalesforceProduct | null {
    const normalizedMembers = this.getNormalizedMembers();
    const productSelector = new ProductSelectorService(normalizedMembers);
    return productSelector.getSelectedProduct();
  }
}
